export default {
  hero: {
    title: 'Comprehensive Customer Support Services',
    subtitle: 'From requirement gathering to continuous optimization, we provide full lifecycle professional support to ensure your business runs smoothly'
  },
  serviceProcess: {
    title: 'Service Process',
    steps: {
      step1: {
        title: 'Requirement Gathering',
        description: 'Deep understanding of your business needs, providing professional consulting'
      },
      step2: {
        title: 'Solution Design',
        description: 'Customized solutions tailored to meet your business requirements'
      },
      step3: {
        title: 'Implementation',
        description: 'Professional team ensures efficient implementation and seamless deployment'
      },
      step4: {
        title: 'Operations Support',
        description: '7×24 monitoring and rapid issue response'
      },
      step5: {
        title: 'Optimization & Upgrade',
        description: 'Continuous system performance optimization and upgrade recommendations'
      }
    }
  },
  helpCenter: {
    title: 'Help Center',
    categories: {
      title: 'FAQ Categories',
      service: 'Service Inquiry',
      trouble: 'Issue Reporting',
      compliance: 'Compliance Query',
      technical: 'Technical Support',
      account: 'Account Management'
    },
    needMoreHelp: 'Need More Help?',
    onlineSupport: 'Online Customer Service',
    searchPlaceholder: 'Search help center...',
    faq: {
      service: {
        title: 'Service Inquiry',
        q1: {
          question: 'What types of technical support services does Global Data provide?',
          answer: {
            intro: 'Global Data provides comprehensive technical support services, including:',
            list: [
              '7×24 system monitoring and incident response',
              'Remote technical support and problem diagnosis',
              'Regular system health checks and performance optimization',
              'Security vulnerability assessment and remediation recommendations',
              'System upgrade and migration support',
              'Customized training services'
            ],
            conclusion: 'We offer different service tiers based on customer needs, from basic support to enterprise-level dedicated service teams.'
          }
        },
        q2: {
          question: 'How to apply for new services or upgrade existing services?',
          answer: {
            intro: 'You can apply for new services or upgrade existing services through:',
            list: [
              'Log in to the customer management platform and submit an application on the "Service Management" page',
              'Send an email to {serviceEmail} with your requirements',
              'Call customer service hotline 400-123-4567',
              'Consult in real-time through the online customer service system'
            ],
            conclusion: 'Our service team will contact you within 1 business day to discuss specific requirements and implementation plans.'
          }
        },
        q3: {
          question: 'How long is the service contract valid? How to renew?',
          answer: {
            intro: 'The standard service contract is valid for 1 year. We will send you a renewal reminder 30 days before the contract expires. The renewal process is simple:',
            list: [
              'Log in to the customer management platform to view renewal options',
              'Confirm service content and pricing',
              'Sign the electronic contract online',
              'Complete payment'
            ],
            conclusion: 'Long-term partners enjoy preferential pricing and additional service benefits.'
          }
        }
      },
      trouble: {
        title: 'Issue Reporting',
        content: 'Issue reporting related FAQ content will be displayed here...'
      },
      compliance: {
        title: 'Compliance Query',
        content: 'Compliance query related FAQ content will be displayed here...'
      },
      technical: {
        title: 'Technical Support',
        content: 'Technical support related FAQ content will be displayed here...'
      },
      account: {
        title: 'Account Management',
        content: 'Account management related FAQ content will be displayed here...'
      }
    },
    instantHelp: {
      title: 'Need Immediate Help?',
      subtitle: 'Our technical support team is ready to assist you',
      hotline: 'Service Hotline',
      hotlineValue: '400-123-4567',
      email: 'Email',
      emailLocalPart: 'support',
      serviceTime: 'Service Hours',
      serviceTime24x7: '7×24 Hours',
      contactSupport: 'Contact Technical Support'
    }
  },
  sla: {
    title: 'Service Level Agreement (SLA)',
    description: 'We commit to providing corresponding levels of service guarantees for customers with different needs. Below is an overview of our service level agreements. For detailed SLA documents, please contact your account manager.',
    table: {
      serviceItem: 'Service Item',
      enterprise: 'Enterprise',
      professional: 'Professional',
      standard: 'Standard',
      responseTime: 'Response Time',
      criticalResolution: 'Resolution Time (Critical)',
      generalResolution: 'Resolution Time (General)',
      availability: 'System Availability',
      supportMethod: 'Support Method',
      supportMethod_enterprise: 'Phone + Remote + Onsite',
      supportMethod_professional: 'Phone + Remote',
      supportMethod_standard: 'Remote Support',
      accountManager: 'Dedicated Account Manager',
      compensation: 'Compensation (Service Interruption)',
      compensation_enterprise: 'Service Duration × 50',
      compensation_professional: 'Service Duration × 30',
      compensation_standard: 'Service Duration × 10',
      values: {
        responseTime: { enterprise: '15 minutes', professional: '1 hour', standard: '4 hours' },
        criticalResolution: { enterprise: '2 hours', professional: '8 hours', standard: '24 hours' },
        generalResolution: { enterprise: '8 hours', professional: '24 hours', standard: '48 hours' },
        availability: { enterprise: '99.99%', professional: '99.9%', standard: '99.5%' }
      }
    },
    levels: {
      enterprise: {
        title: 'Enterprise Service',
        description: 'Provides the highest level of guarantee for critical business systems, suitable for large enterprises with extremely high system stability requirements.',
        features: [
          '7×24 dedicated support team',
          '15-minute rapid response',
          'Onsite support service',
          'Quarterly system health checks'
        ],
        learnMore: 'Learn More'
      },
      professional: {
        title: 'Professional Service',
        description: 'Provides comprehensive guarantees for important business systems, suitable for core business systems of medium to large enterprises.',
        features: [
          'Weekday 8×12 hours support',
          '1-hour response time',
          'Remote priority support',
          'Semi-annual system health checks'
        ],
        learnMore: 'Learn More'
      },
      standard: {
        title: 'Standard Service',
        description: 'Provides basic guarantees for general business systems, suitable for small enterprises or non-core business systems.',
        features: [
          'Weekday 8-hour support',
          '4-hour response time',
          'Remote support service',
          'Annual system health checks'
        ],
        learnMore: 'Learn More'
      }
    }
  },
  feedback: {
    title: 'After-Sales Feedback & Complaints',
    subtitle: 'The service evaluation feature has been removed. If you need to report an issue, share suggestions, or file a complaint, please use the channels below and we will follow up promptly.',
    evaluation: {
      title: 'Service Evaluation',
      subtitle: 'Your feedback is very important to us and helps us continuously improve service quality',
      serviceType: 'Service Type',
      serviceTypePlaceholder: 'Please select service type',
      serviceTypes: {
        technical: 'Technical Support',
        consulting: 'Consulting Service',
        implementation: 'Implementation',
        training: 'Training Service',
        other: 'Other Services'
      },
      satisfaction: 'Overall Satisfaction',
      detailedFeedback: 'Detailed Feedback',
      feedbackPlaceholder: 'Please share your experience and suggestions about our service...',
      acceptNotification: 'I agree to receive notifications about subsequent service improvements',
      submit: 'Submit Evaluation',
      successMessage: 'Thank you for your feedback! We will carefully consider your comments.'
    },
    complaint: {
      title: 'Feedback & Complaint Channels',
      subtitle: 'If you need to report issues or request escalation during delivery, operations, response, or communication, please use the channels below. We will respond as soon as possible during service hours.',
      hotline: {
        title: 'Complaint Hotline',
        phone: '400-123-4567 ext. 8',
        time: 'Service Hours: Weekdays 9:00-18:00'
      },
      email: {
        title: 'Complaint Email',
        localPart: 'complaint',
        response: 'We will reply to your email within 24 hours'
      },
      online: {
        title: 'Online Complaint',
        description: 'Submit a complaint form via customer management platform',
        tracking: 'Complaint processing progress can be tracked in real-time'
      },
      process: {
        title: 'Complaint Processing Flow',
        steps: [
          'Submit feedback or complaint details',
          'Customer service confirms receipt (within 24 hours)',
          'Relevant department investigates',
          'Provide a solution or handling plan',
          'Customer confirms the handling result'
        ]
      }
    }
  },
  cta: {
    title: 'Need More Help?',
    subtitle: 'Our customer support team is ready to provide professional services and solve any issues you encounter',
    contactSupport: 'Contact Customer Support',
    viewDocumentation: 'View Help Documentation'
  },
  chat: {
    title: 'Online Customer Service',
    placeholder: 'Enter your question...',
    welcome: 'Hello! I am an intelligent customer service assistant. How can I help you?',
    assistant: 'Customer Service',
    me: 'Me',
    justNow: 'Just now',
    autoReply: 'Thank you for your inquiry. Our customer service staff will reply to you soon.'
  }
}
